import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { PreferredTimeOff } from '../../../models/employee/PreferredTimeOff';
import { DayOfWeek } from '../../../enums/DayOfWeek';
import { EmployeeWeeklyPreferredTimeOffResponse } from '../../../../interfaces/response/EmployeeResponse';

/**
 * An adapter converts preferred time off HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class PreferredTimeOffAdapter implements Adapter<Map<string, PreferredTimeOff[]>> {

  /**
   * Converts preferred time off HTTP response to a map of date a list of {@link PreferredTimeOff}.
   * @param item preferred time off HTTP response.
   */
  adapt(item: EmployeeWeeklyPreferredTimeOffResponse[]): Map<string, PreferredTimeOff[]> {
    if (!item) {
      return null;
    }

    const result = new Map<string, PreferredTimeOff[]>();
    item.map($item => {
      const monday = $item.monday;
      const tuesday = $item.tuesday;
      const wednesday = $item.wednesday;
      const thursday = $item.thursday;
      const friday = $item.friday;
      const saturday = $item.saturday;
      const sunday = $item.sunday;
      const weeklyTimes: PreferredTimeOff[] = [];
      if (monday) {
        weeklyTimes.push(new PreferredTimeOff(DayOfWeek.MONDAY, monday.reason, monday.startTime, monday.endTime, $item.date));
      }
      if (tuesday) {
        weeklyTimes.push(new PreferredTimeOff(DayOfWeek.TUESDAY, tuesday.reason, tuesday.startTime, tuesday.endTime, $item.date));
      }
      if (wednesday) {
        weeklyTimes.push(new PreferredTimeOff(DayOfWeek.WEDNESDAY, wednesday.reason, wednesday.startTime, wednesday.endTime, $item.date));
      }
      if (thursday) {
        weeklyTimes.push(new PreferredTimeOff(DayOfWeek.THURSDAY, thursday.reason, thursday.startTime, thursday.endTime, $item.date));
      }
      if (friday) {
        weeklyTimes.push(new PreferredTimeOff(DayOfWeek.FRIDAY, friday.reason, friday.startTime, friday.endTime, $item.date));
      }
      if (saturday) {
        weeklyTimes.push(new PreferredTimeOff(DayOfWeek.SATURDAY, saturday.reason, saturday.startTime, saturday.endTime, $item.date));
      }
      if (sunday) {
        weeklyTimes.push(new PreferredTimeOff(DayOfWeek.SUNDAY, sunday.reason, sunday.startTime, sunday.endTime, $item.date));
      }
      result.set($item.date, weeklyTimes);
    });
    return result;
  }
}
